const ListItemButton = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius * 1.5,
      padding: theme.spacing(2.5, 4),
      justifyContent: "center",
      alignItems: "center",
      gap: 5,
    }),
  },
};

export default ListItemButton;
